module.exports = __webpack_public_path__ + "img/checked.c576e83.png";